export enum MindfulnessPathsEnum {
  ROOT = "mindfulness",
}

export enum MindfulnessRoutesEnum {
  ROOT = "/mindfulness",
}
